import { useField } from 'formik';
import React, { useCallback } from 'react';
import FormDatePicker, { FormDatePickerProps } from './FormDatePicker';

export type FormikFormDatePickerProps = Omit<
  FormDatePickerProps,
  'error' | 'touched' | 'onChange' | 'date'
>;

const FormikFormDatePicker: React.FunctionComponent<FormikFormDatePickerProps> = props => {
  const [field, fieldMeta, { setValue, setTouched }] = useField<Date | null>(
    props.name,
  );

  const onChange = useCallback(
    (newValue: Date | null) => {
      setTouched(true);
      setValue(newValue);
    },
    [setValue, setTouched],
  );

  return (
    <FormDatePicker
      {...props}
      name={field.name}
      date={field.value ?? undefined}
      error={fieldMeta.error}
      touched={fieldMeta.touched}
      onChange={onChange}
    />
  );
};

export default FormikFormDatePicker;
